import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular-ivy';
import { environment } from '@app/../environments/environment';

@Injectable()
export class SentryErrorHandler implements ErrorHandler {
  
  handleError(error: any): void {
    // Always log to console for debugging
    console.error('Global Error Handler:', error);
    
    // Send to Sentry if enabled
    if (environment.sentry.enabled && environment.sentry.dsn) {
      try {
        // Extract the actual error
        const extractedError = this.extractError(error) || error;
        Sentry.captureException(extractedError);
      } catch (sentryError) {
        console.error('Error reporting to Sentry:', sentryError);
      }
    }
  }

  private extractError(error: any): Error | null {
    // Try to extract the actual error from Angular wrapper
    if (error?.rejection) {
      return error.rejection;
    }
    
    if (error?.originalError) {
      return error.originalError;
    }
    
    if (error?.error) {
      return error.error;
    }
    
    if (error instanceof Error) {
      return error;
    }
    
    // If it's a string, create an Error object
    if (typeof error === 'string') {
      return new Error(error);
    }
    
    // If it's an object with a message, create an Error
    if (error?.message) {
      return new Error(error.message);
    }
    
    return null;
  }
}
